/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matches_Reason_UnknownInputs */

const cs_matches_reason_unknown = /** @type {(inputs: Matches_Reason_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoda podle dostupných kritérií`)
};

const en_matches_reason_unknown = /** @type {(inputs: Matches_Reason_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match based on available criteria`)
};

/**
* | output |
* | --- |
* | "Match based on available criteria" |
*
* @param {Matches_Reason_UnknownInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const matches_reason_unknown = /** @type {((inputs?: Matches_Reason_UnknownInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matches_Reason_UnknownInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_matches_reason_unknown(inputs)
	return cs_matches_reason_unknown(inputs)
});